import Vue from 'vue'

Vue.filter('moeda', function(value){

    var lg = JSON.parse(localStorage.getItem("__POLICE_SESSION_LG_"));
    return Number(value).moeda(2, lg.sifrao + ' ', lg.milhar, lg.decimal);
});

Vue.filter('tempoParaDecimal', function(value){

	console.log(Vue)

	if(_.isNil(value)){
		return ''
	}

	let $minutes = value.split(':')[1]
	let $hours = Number(value.split(':')[0])

	var $decimo_hora = 0;

	if ($minutes >= 4 && $minutes <= 9)
	{
		$decimo_hora = 1;
	}
	else if ($minutes >= 10 && $minutes <=15)
	{
		$decimo_hora = 2;
	}
	else if ($minutes >= 16 && $minutes <=21)
	{
		$decimo_hora = 3;
	}
	else if ($minutes >= 22 && $minutes <=27)
	{
		$decimo_hora = 4;
	}
	else if ($minutes >= 28 && $minutes <=33)
	{
		$decimo_hora = 5;
	}
	else if ($minutes >= 34 && $minutes <=39)
	{
		$decimo_hora = 6;
	}
	else if ($minutes >= 40 && $minutes <=45)
	{
		$decimo_hora = 7;
	}
	else if ($minutes >= 46 && $minutes <=51)
	{
		$decimo_hora = 8;
	}
	else if ($minutes >= 52 && $minutes <=57)
	{
		$decimo_hora = 9;
	}
	else if (($minutes >= 58))
	{
		$decimo_hora = 0;
		$hours++;
	}
	else if ($hours != 0)
	{
		$decimo_hora = 0;
	}else
	{
		$decimo_hora = 0;
	}

	return Number($hours)+'.'+ $decimo_hora;

});

Vue.filter('highlight', function(words, query){
    var iQuery = new RegExp(query, "ig");
    return words.toString().replace(iQuery, function(matchedTxt,a,b){
        return ('<span class=\'highlight\'>' + matchedTxt + '</span>');
    });
});

Vue.filter('apPmTo24', function(value){

    if(!_.isNil(value) && value != null && value != 'N/A' && value != ""){
        var time= value +''.toUpperCase();

        var hours = Number(time.match(/^(\d+)/)[1]);
        var minutes = Number(time.match(/:(\d+)/)[1]);
        var AMPM = time.match(/\s(.*)$/)[1].toLowerCase();

        if (AMPM == "pm" && hours < 12) hours = hours + 12;
        if (AMPM == "am" && hours == 12) hours = hours - 12;
        var sHours = hours.toString();
        var sMinutes = minutes.toString();
        if (hours < 10) sHours = "0" + sHours;
        if (minutes < 10) sMinutes = "0" + sMinutes;

        return sHours +':'+sMinutes;
    }

    return ''
})

Vue.filter('decimalToHora', function(value){

    if(_.isNil(value)){
        return '0'
    }
    return value.replace(".", ":")
});

Vue.filter('arredondar1', function(value){

    if(Number(value) == 0) {
        return ''
    }

    return parseFloat(value).toFixed(1)

})

Vue.filter('arredondar', function(value){

    if(Number(value) == 0) {
        return ''
    }

    return parseFloat(value).toFixed(0)

})

Vue.filter('proa', function(value){

    if(Number(value) == 0) {
        return ''
    }

    return Math.round(value)

})


Vue.filter('decimalEmTempo', function(value){

    if(_.isNil(value)){
        return '0'
    }
    var t = value.split(".")
    if(t[1] > 60){

        t[0] = Number(t[0]) + 1;

        t[1] = Number(t[1]) - 60

        return t[0] + ':' + t[1]
    }
});


Vue.filter('data', function(value){

    if(value == "" || value == null || _.isNil(value)){
        return "N/A"
    }

    if($sessao.getDateFormat() == "DD/MM/YYYY"){
        var dt = value.split("-")
        return (dt[2] + "/" + dt[1] + "/" + dt[0])
    }

    if($sessao.getDateFormat() == "MM/DD/YYYY"){
        var dt = value.split("-")
        return (dt[1] + "/" + dt[2] + "/" + dt[0])
    }
});

Vue.filter('dataTempo', function(value){

    if(value == "" || value == null || _.isNil(value)){
        return ""
    }

    if($sessao.getDateFormat() == "DD/MM/YYYY"){
        var dt = value.split(" ")
        return (dt[0].split("-")[2] + "/" + dt[0].split("-")[1] + "/" + dt[0].split("-")[0] +" "+ dt[1].split(':')[0] + ':' + dt[1].split(':')[1])
    }

    if($sessao.getDateFormat() == "MM/DD/YYYY"){
        var dt = value.split(" ")
        return (dt[0].split("-")[1] + "/" + dt[0].split("-")[2] + "/" + dt[0].split("-")[0] +" "+ dt[1].split(':')[0] + ':' + dt[1].split(':')[1])

    }
});

Vue.filter('tempo', function(value){

    if(value == "" || value == null || _.isNil(value)){
        return ""
    }
    var dt = value.split(' ')[1]
    var ht = dt.split(':')
    return ht[0] +':'+ht[1]
});


Vue.filter('dataSemTempo', function(value){

    if(value == "" || value == null || _.isNil(value)){
        return ""
    }

    if($sessao.getDateFormat() == "DD/MM/YYYY"){
        var dt = value.split(" ")
        return (dt[0].split("-")[2] + "/" + dt[0].split("-")[1] + "/" + dt[0].split("-")[0])
    }

    if($sessao.getDateFormat() == "MM/DD/YYYY"){
        var dt = value.split(" ")
        return (dt[0].split("-")[1] + "/" + dt[0].split("-")[2] + "/" + dt[0].split("-")[0])

    }
});


Vue.filter('decimal', function(value){

    var lg = JSON.parse(localStorage.getItem("__POLICE_SESSION_LG_"));
    return Number(value).moeda(1, '', lg.milhar, lg.decimal);

});

Vue.filter('na', function(item){

    if(_.isNil(item) || item == ''){
        return 'N/A'
    }

    return item
});


Vue.filter('moeda', function(value){

    var lg = JSON.parse(localStorage.getItem("__POLICE_SESSION_LG_"));
    return lg.sifrao +' '+ Number(value).toFixed(2).moeda(2, '', lg.milhar, lg.decimal);

});

Vue.filter('horimetro', function(value){

    if(value == null || value == ''){
        return '0,0'
    }

    var lg = JSON.parse(localStorage.getItem("__POLICE_SESSION_LG_"));
    return parseFloat(value).toFixed(1).moeda(1, '', lg.milhar, lg.decimal);

});

Vue.filter('horimetro2', function(value){

    if(value == null || value == ''){
        return '0,00'
    }

    var lg = JSON.parse(localStorage.getItem("__POLICE_SESSION_LG_"));
    return parseFloat(value).toFixed(2).moeda(2, '', lg.milhar, lg.decimal);

});

Vue.filter('formataTempo', function(value){

    if(!_.isNil(value) && value != NaN && value != 'N/A' && value != ''){
        var vr = value.split(":")

        var hora = Number(vr[0]) < 10 ? "0" + Number(vr[0]) : vr[0]
        var minuto = Number(vr[1]) < 10 ? "0" + Number(vr[1]) : vr[1]

        return hora +':'+ minuto
    }

    return 'N/A'


})


Vue.filter('formataDataSubstring', function(value){

    if(!_.isNil(value) && value != NaN && value != 'N/A'){

		if(Number(value)){
			return `${value.substring(4, 6)}/${value.substring(2, 4)}/${value.substring(0, 2)} ${value.substring(6, 8)}:${value.substring(8, 10)}`
		}

		return value
    }

    return 'N/A'


})

Vue.filter('numeroNegativo', (val) => {
	const numero = Number(val).toFixed(1)
	return numero >= 0 ? numero : 'N/A'
})
